import { forwardRef } from 'react';
import { styled } from 'goober';
import { Link } from 'react-router-dom';

export const DropDownContainer = styled('section', forwardRef)`
  background: #fff;
  box-shadow: 0 0 16px rgba(36, 37, 39, 0.16), 0 0 0 rgba(36, 37, 39, 0.08);
  display: flex;
  flex-direction: column;
  z-index: 20;
  padding: 16px 0;
  box-sizing: border-box;
  border-radius: 10px;
  position: absolute;
  top: 40px;
`;

const Item = styled(Link)`
  font-family: 'Noto Sans', sans-serif;
  text-decoration: none;
  color: #42abe9;
  outline: none;
  line-height: 32px;
  padding: 0 30px;
  font-size: 14px;
  text-align: left;

  &:hover {
    background: #f6fbff;
    color: #018dbf;
  }
`;

export const DropDown = ({ data }) => (
  <DropDownContainer>
    {data.map((tab) => (
      <Item to={tab.link}>{tab.heading}</Item>
    ))}
  </DropDownContainer>
);
